import { Model } from "@shared-features/models/model";
import { Expose } from "class-transformer";

export class FleetsTrucksDriversCounts extends Model {
    @Expose() totalFleetsCount:               number;
    @Expose() totalTrucksCount:               number;
    @Expose() totalTrucksVerifiedByElmCount:  number;
    @Expose() totalDriversCount:              number;
    @Expose() totalDriversVerifiedByElmCount: number;
    @Expose() lastRefreshTime:                number;
}
